/**
 * Skeleton
 * --------
 * The skeleton component is used to show a loading state for a component.
 * Commonly when used, they are given a height and a width matching the element is being loaded.
 */

interface SkeletonProps {
    className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className }) => {
    return <div className={`animate-pulse bg-gray-200 rounded ${className}`} />;
  }
  